import React from "react";
import {
  BlockContainer,
  InnerBlockContainer,
  InnerNarrowBlockContainer,
  InnerNarrowBlockContentContainer,
} from "BaseComponents/Wrappers";
import LazyImage from "../../framework/lazy/LazyImage";
import {getResponsiveImage} from "Helpers/ImageHelper";
import {Paragraph} from "BaseComponents/Text/";

export const ImageBlock = ({
                             ResponsiveImage,
                             Description,
                             NarrowText,
                             PageCenterContent,
                           }) => {
  let responsiveImage = getResponsiveImage(ResponsiveImage);
  let alt = ResponsiveImage.Alt;

  return (
    <BlockContainer className="imageBlock" narrowText={NarrowText}>
      <InnerBlockContainer narrowText={NarrowText}>
        <InnerNarrowBlockContainer
          narrowText={NarrowText}
          centerContent={PageCenterContent}
        >
          <InnerNarrowBlockContentContainer narrowText={NarrowText}>
            <LazyImage
              source={responsiveImage}
              height="100%"
              display="flex"
              borderRadius="8px"
              alt={alt}
            />
            {Description && <Paragraph>{Description}</Paragraph>}
          </InnerNarrowBlockContentContainer>
        </InnerNarrowBlockContainer>
      </InnerBlockContainer>
    </BlockContainer>
  );
};
